<template>
  <div class="help-list">
    <ul>
      <li
        v-for="(item, index) in items"
        :key="index"
        
        class="help-list__item"
        
        v-html="item"
      />
    </ul>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

// Export
export default {
  name: 'module-help-list',

  props: {
    items: Array,
  },

  computed: {
    ...mapGetters('app', ['org']),
  },

};
</script>



// WEBPACK FOOTER //
// HelpList.vue?01435054